import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail } from 'lucide-react';
import { navigationLinks, siteData } from '../../data/mock';
import { useLanguage } from '../../context/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer className="bg-[#0e1112] text-[#9AACB8]">
      {/* Compact bottom block — brand + nav inline + contact */}
      <div className="pt-20 pb-12 md:pt-24 md:pb-14">
        <div className="container-swg">
          <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
          {/* Brand cluster */}
          <Link to="/home" className="flex items-center gap-4 group" data-testid="footer-logo-link">
            <img
              src="/logos/swg-icon.png"
              alt="Smartworld Group"
              className="h-14 w-auto object-contain transition-transform duration-300 group-hover:scale-105 drop-shadow-[0_0_18px_rgba(91,122,138,0.4)]"
              data-testid="footer-logo-img"
            />
            <div className="leading-tight">
              <div className="text-2xl font-black tracking-tight text-white">SWG</div>
              <div className="text-[10px] font-medium tracking-[0.25em] uppercase text-[#5B7A8A]">Smartworld Group</div>
            </div>
          </Link>

          {/* Inline navigation */}
          <nav className="flex flex-wrap items-center gap-x-7 gap-y-2">
            {navigationLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className="text-[#9AACB8] hover:text-white transition-colors text-sm font-medium"
              >
                {t(`nav.${link.key}`)}
              </Link>
            ))}
          </nav>

          {/* Social cluster */}
          <div className="flex items-center gap-3">
            <a
              href={`mailto:${siteData.emails.contact}`}
              aria-label="Email"
              className="w-10 h-10 border border-[rgba(91,122,138,0.3)] rounded-full flex items-center justify-center text-[#9AACB8] hover:text-[#5B7A8A] hover:border-[#5B7A8A] transition-colors"
            >
              <Mail className="w-4 h-4" />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LinkedIn"
              className="w-10 h-10 border border-[rgba(91,122,138,0.3)] rounded-full flex items-center justify-center text-[#9AACB8] hover:text-[#5B7A8A] hover:border-[#5B7A8A] transition-colors"
            >
              <Linkedin className="w-4 h-4" />
            </a>
          </div>
        </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-[rgba(91,122,138,0.15)]">
        <div className="container-swg py-5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-3">
            <p className="text-[#9AACB8] text-xs tracking-wide opacity-70">
              © {new Date().getFullYear()} Smartworld Group · {t('footer.rights')}
            </p>
            <a
              href="https://emergent.sh"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1 text-[8px] tracking-[0.2em] uppercase text-[#9AACB8]/40 hover:text-[#5B7A8A] transition-colors"
              data-testid="footer-made-with-emergent"
            >
              Made with
              <span className="font-semibold">Emergent</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
